{#if $isUserLoggedIn}
  <TimelinePage timeline="bookmarks">
    {#if $pinnedPage !== '/bookmarks'}
      <DynamicPageBanner title="{$messages["bookmarks"]}" icon="#fa-bookmark"/>
    {/if}
  </TimelinePage>
{:else}
  <HiddenFromSSR>
    <FreeTextLayout>
      <h1>{$messages["bookmarks"]}</h1>

      <p>{$messages["bookmarksNotLoggedIn"]}</p>
    </FreeTextLayout>
  </HiddenFromSSR>
{/if}
<script>
  import TimelinePage from '../_components/TimelinePage.html'
  import FreeTextLayout from '../_components/FreeTextLayout.html'
  import { store } from '../_store/store.js'
  import HiddenFromSSR from '../_components/HiddenFromSSR.html'
  import DynamicPageBanner from '../_components/DynamicPageBanner.html'

  export default {
    store: () => store,
    components: {
      TimelinePage,
      FreeTextLayout,
      HiddenFromSSR,
      DynamicPageBanner
    }
  }
</script>
